import React from 'react';
import { ButtonPest } from '../../../../../../utils/Button';
import { EditIcon } from '../../../../../../utils/SVGIcon';
import { TextCapitalize } from '../../../../../../utils/TextFormatter';
import cn from '../../../../../../utils/cn';
import { useServiceDt } from '../../ServiceDetailsProvider';

function TableRow({ item, handleSelectPackage, isServiceInactive, handleEditClick }) {
    const { packageInfo, isSelected } = useServiceDt();
    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo,
                '!bg-secondary-50 hover:!bg-secondary-50 border-transparent':
                    packageInfo?.id === item?.id && isSelected && !item?.demo
            })}
        >
            <td className={packageInfo?.id === item?.id && isSelected ? 'rounded-l-10' : ''}>
                <span>{item?.id}</span>
            </td>
            <td
                className={cn(
                    'group-hover:text-secondary group-hover:font-medium hover:underline !cursor-pointer',
                    {
                        'underline [&>span]:text-secondary [&>span]:font-medium':
                            packageInfo?.id === item?.id && isSelected && !item?.demo
                    }
                )}
                onClick={(ev) => handleSelectPackage(ev, item)}
            >
                <span>{item?.packageName}</span>
            </td>
            <td className="text-left">
                <span>{TextCapitalize(item?.packageForRole) || '--'}</span>
            </td>
            <td className="text-center">
                <span>{item?.pricing?.length || 0}</span>
            </td>
            <td className="text-center">
                <span className={item?.isPublic ? 'text-secondary' : 'text-warning'}>
                    {item?.isPublic ? 'Yes' : 'No'}
                </span>
            </td>
            <td className="text-center">
                <span className={item?.status === 'active' ? 'text-success' : '!text-warning'}>
                    {TextCapitalize(item?.status) || '--'}
                </span>
            </td>

            <td
                className={`!pr-5 ${
                    packageInfo?.id === item?.id && isSelected ? 'rounded-r-10' : ''
                }`}
            >
                <div className="flex w-full justify-end">
                    <button
                        type="button"
                        onClick={(ev) => handleEditClick(ev, item)}
                        disabled={isServiceInactive || item?.demo}
                        className={`size-[31px] p-[7px] rounded-[7px] bg-secondary-100 text-secondary transition-colors disabled:grayscale disabled:cursor-default disabled:select-none disabled:hover:bg-secondary-100 disabled:hover:text-secondary ${
                            packageInfo?.id !== item?.id
                                ? 'hover:bg-secondary hover:text-white'
                                : ''
                        }`}
                    >
                        <EditIcon />
                    </button>
                </div>
            </td>
        </tr>
    );
}
function TableHeader() {
    return (
        <thead>
            <tr className="*:!cursor-default">
                <th>
                    <span>ID</span>
                </th>
                <th>
                    <span>Package Name</span>
                </th>
                <th scope="col" className="text-left w-24">
                    <span>Role</span>
                </th>
                <th scope="col" className="text-center w-36">
                    <span>Total Prices</span>
                </th>
                <th scope="col" className="text-center w-20">
                    <span>Public</span>
                </th>
                <th scope="col" className="text-center w-20">
                    <span>Status</span>
                </th>
                <th scope="col">
                    <span>#</span>
                </th>
            </tr>
        </thead>
    );
}

function TableWeb({ data, isServiceInactive, openModal, handleSelectPackage, handleEditClick }) {
    return (
        <div className="package_page_table mb-40">
            <table className="bik-table mb-4" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody className="">
                    {data?.map((item) => (
                        <TableRow
                            key={item?.id}
                            item={item}
                            handleSelectPackage={handleSelectPackage}
                            isServiceInactive={isServiceInactive}
                            handleEditClick={handleEditClick}
                        />
                    ))}
                </tbody>
            </table>

            <div className={`flex justify-end ${data?.[0]?.demo ? 'hidden' : 'block'}`}>
                <ButtonPest
                    title="Add Package +"
                    disabled={isServiceInactive}
                    onClick={() => openModal('addPackage')}
                />
            </div>
        </div>
    );
}

export default TableWeb;
